import { render, staticRenderFns } from "./rightBottom4.vue?vue&type=template&id=59e9347c&scoped=true"
import script from "./rightBottom4.vue?vue&type=script&lang=js"
export * from "./rightBottom4.vue?vue&type=script&lang=js"
import style0 from "./rightBottom4.vue?vue&type=style&index=0&id=59e9347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9347c",
  null
  
)

export default component.exports